import { FC, useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  CardHeader,
  Container,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import styled from '@emotion/styled';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getEmployeeById,
  getEmployeeDesignationHistory,
  updateEmployeeInformation
} from 'src/services/employeeService';
import {
  EmployeeDesignationHistory,
  EmployeeInformation,
  UpdateEmployee
} from 'src/models/employee';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import { SnackBar } from 'src/components/SnackBar';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import { useForm } from 'react-hook-form';
import { AppActions } from 'src/store/AppReducer';
import EmployeePromoteForm from '../employee/EmployeePromoteForm';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { PieChart } from 'react-minimal-pie-chart';

interface EmployeeEditProps {}

const ProjectProfile: FC<EmployeeEditProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { employeeId } = useParams();

  const [open, setOpen] = useState(false);
  const [empName, setEmpName] = useState('');

  const [employeeInformation, setEmployeeInformation] = useState(
    {} as UpdateEmployee
  );
  const { register, handleSubmit, reset, setValue } = useForm<UpdateEmployee>();

  let designationsInitial: EmployeeDesignationHistory[] = [];
  const [designation, setEmployeeDesigntionHistory] =
    useState(designationsInitial);

  useEffect(() => {
    /* getEmployeeById(employeeId).then((res) => {
      setEmployeeInformation(res.data as UpdateEmployee);
      setEmpName(res.data.name);
    }).catch(() => {
      navigate("/status/404");
    });
    

    getEmployeeDesignationHistory(employeeId).then((res) => {
      setEmployeeDesigntionHistory(res.data as EmployeeDesignationHistory[]);
    }); */
  }, []);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
    .MuiCardHeader-action{
      width: 100%
    }
  `
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = (data: UpdateEmployee) => {
    updateEmployeeInformation(employeeInformation)
      .then((res) => {
        setEmployeeInformation(res.data as UpdateEmployee);
        setEmpName(res.data.name);
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Employee Updated Successfully',
            severity: 'success'
          })
        );
      })
      .catch(() => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Unable to Edit the Employee',
            severity: 'error'
          })
        );
      });
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }));

  const handleEdit = () => {
    navigate('/project-details/project-edit/SDE');
  };

  return (
    <>
      <PageTitleWrapper>
        <Grid container direction={'row'} sx={{ pl: 2 }}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/project-details');
              }}
              style={{ cursor: 'pointer' }}
              variant="h3"
              component="h3"
            >
              {' '}
              Project Details /<span style={{ fontSize: 16 }}> Ooredoo </span>
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h3"
              component="h3"
            >
              {' '}
              {empName}{' '}
            </Typography>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <Grid container sx={{ justifyContent: 'space-between' }}>
                <Grid
                  xs={12}
                  md={6}
                  className="project-chart-wrapper"
                  item
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start'
                  }}
                >
                  <Grid
                    className="project-image-wrapper"
                    item
                    sx={{ pl: 4, py: 3, pr: 6 }}
                  >
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      <img
                        alt="logo"
                        style={{ height: 70 }}
                        src={process.env.PUBLIC_URL + '/img/user.png'}
                      />
                      <Grid item sx={{ pl: 2 }}>
                        <Typography variant="h4">Ooredoo</Typography>
                        <Typography
                          variant="h5"
                          style={{ fontWeight: 'normal', paddingTop: 5 }}
                        >
                          OND
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    className="project-image-wrapper"
                    item
                    sx={{ pl: 4, py: 3, pr: 6 }}
                  >
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}
                    >
                      <Stack
                        sx={{ width: '100%', color: 'grey.500' }}
                        spacing={2}
                      >
                        <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Grid
                            style={{ paddingBottom: 3 }}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between'
                            }}
                          >
                            <Typography
                              className="progress-text"
                              style={{ fontWeight: 'normal', color: '#232C68' }}
                              variant="body1"
                            >
                              Project Completion
                            </Typography>
                            <Typography
                              className="progress-text"
                              style={{ fontWeight: 'normal', color: '#232C68' }}
                              variant="body1"
                            >
                              75%
                            </Typography>
                          </Grid>
                          <LinearProgress
                            variant="determinate"
                            value={75}
                            color="primary"
                          />
                        </Grid>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            pt: 1
                          }}
                        >
                          <Grid
                            style={{ paddingBottom: 3 }}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between'
                            }}
                          >
                            <Typography
                              className="progress-text"
                              style={{ fontWeight: 'normal', color: '#232C68' }}
                              variant="body1"
                            >
                              Project Actual Effort Status
                            </Typography>
                            <Typography
                              className="progress-text"
                              style={{ fontWeight: 'normal', color: '#232C68' }}
                              variant="body1"
                            >
                              132%
                            </Typography>
                          </Grid>
                          <LinearProgress
                            variant="determinate"
                            value={100}
                            color="error"
                          />
                        </Grid>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            pt: 1
                          }}
                        >
                          <Grid
                            style={{ paddingBottom: 3 }}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between'
                            }}
                          >
                            <Typography
                              className="progress-text"
                              style={{ fontWeight: 'normal', color: '#232C68' }}
                              variant="body1"
                            >
                              Remaining Effort
                            </Typography>
                            <Typography
                              className="progress-text"
                              style={{ fontWeight: 'normal', color: '#232C68' }}
                              variant="body1"
                            >
                              75%
                            </Typography>
                          </Grid>
                          <LinearProgress
                            variant="determinate"
                            value={75}
                            color="primary"
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                  </Grid>
                  <Grid className="" item sx={{ pl: 4, py: 3, pr: 6 }}>
                    <Typography
                      variant="h4"
                      sx={{ pt: 1, pb: 3, fontSize: 12 }}
                    >
                      Project Actual Hours Distribution
                    </Typography>
                    <Grid
                      item
                      sx={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <Grid
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                      >
                        <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
                          <Grid style={{ width: '50%' }}>
                            <PieChart
                              data={[
                                { title: 'One', value: 10, color: '#DA4C61' },
                                { title: 'Two', value: 15, color: '#A1D0C9' },
                                { title: 'Three', value: 20, color: '#ECC44D' },
                                { title: 'One', value: 10, color: '#6C898F' },
                                { title: 'Two', value: 15, color: '#E8DED3' },
                                { title: 'Three', value: 20, color: '#3C3D51' },
                                { title: 'Two', value: 15, color: '#A19876' }
                              ]}
                              lineWidth={40}
                            />
                            {/* <span style={{fontSize: 10}}>Total Planned - </span> */}
                          </Grid>
                          <Grid
                            style={{ width: '50%' }}
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              paddingLeft: 3,
                              justifyContent: 'space-evenly'
                            }}
                          >
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#DA4C61' }}
                                ></span>
                                <span className="circle-text">BA</span>
                              </Grid>
                              <span className="circle-hours">571 hrs</span>
                            </Grid>
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#A1D0C9' }}
                                ></span>
                                <span className="circle-text">DEV</span>
                              </Grid>
                              <span className="circle-hours">1684 hrs</span>
                            </Grid>
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#ECC44D' }}
                                ></span>
                                <span className="circle-text">PM</span>
                              </Grid>
                              <span className="circle-hours">98 hrs</span>
                            </Grid>
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#6C898F' }}
                                ></span>
                                <span className="circle-text">QA</span>
                              </Grid>
                              <span className="circle-hours">496 hrs</span>
                            </Grid>
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#E8DED3' }}
                                ></span>
                                <span className="circle-text">SM</span>
                              </Grid>
                              <span className="circle-hours">201 hrs</span>
                            </Grid>
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#3C3D51' }}
                                ></span>
                                <span className="circle-text">DEC</span>
                              </Grid>
                              <span className="circle-hours">364 hrs</span>
                            </Grid>
                            <Grid
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <Grid
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center'
                                }}
                              >
                                <span
                                  className="circle"
                                  style={{ backgroundColor: '#A19876' }}
                                ></span>
                                <span className="circle-text">Others</span>
                              </Grid>
                              <span className="circle-hours">0 hrs</span>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          pt: 1,
                          fontSize: 10,
                          justifyContent: 'space-between'
                        }}
                      >
                        <span>Total Planned - </span>
                        <span>Total Spend - 3416 hrs</span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  xs={12}
                  md={6}
                  item
                  style={{
                    overflow: 'auto',
                    maxHeight: '90vh',
                    paddingBottom: '40px',
                    paddingTop: '32px',
                    paddingLeft: '40px',
                    paddingRight: '40px'
                  }}
                >
                  <form>
                    <Grid
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end'
                      }}
                    >
                      <Grid item xs={8}>
                        <Typography variant="h4" sx={{ ml: 1, mt: 0, mb: 3 }}>
                          General Details
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Button
                          sx={{
                            marginRight: 2,
                            mb: 3,
                            fontSize: '0.7rem',
                            alignItems: 'center',
                            fontWeight: 'normal'
                          }}
                          variant="contained"
                          onClick={() => handleEdit()}
                        >
                          <EditIcon
                            sx={{ marginRight: 1, fontSize: '14px' }}
                            fontSize={'inherit'}
                          />
                          Edit
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ pt: 2 }}>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">Project Name</Typography>
                          <TextField
                            size="small"
                            placeholder="Project Name"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">Project Code</Typography>
                          <TextField
                            size="small"
                            placeholder="Project Code"
                            variant="outlined"
                            disabled
                            value="ORD"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Project Group
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Project Group"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Project Nature
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Project Nature"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">Project Type</Typography>
                          <TextField
                            size="small"
                            placeholder="Project Type"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">Country</Typography>
                          <TextField
                            size="small"
                            placeholder="Country"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">Client</Typography>
                          <TextField
                            size="small"
                            placeholder="Client"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Client Stakeholder
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Client Stakeholder"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Client Region
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Client Region"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">Sold By</Typography>
                          <TextField
                            size="small"
                            placeholder="Sold By"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Project Status
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Project Status"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Project Completion (%)
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Project Completion (%)"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Project State Note
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Project State Note"
                            variant="outlined"
                            disabled
                            multiline
                            rows={3}
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Typography variant="h4" sx={{ pt: 4, pb: 2 }}>
                      Financial Details
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Billing Category
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Billing Category"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">SOW Price</Typography>
                          <TextField
                            size="small"
                            placeholder="SOW Price"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Payment Status
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Payment Status"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            SOW / PO Status
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="SOW / PO Status"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">PO Status</Typography>
                          <TextField
                            size="small"
                            placeholder="PO Status"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Note for Invoice
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Note for Invoice"
                            variant="outlined"
                            disabled
                            multiline
                            rows={3}
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Typography variant="h4" sx={{ pt: 4, pb: 2 }}>
                      Time Estimation
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Planned Hours
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Planned Hours"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Pre-sale Start Date
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Pre-sale Start Date"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Actual Start Date
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Actual Start Date"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Pre-sale End Date
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Pre-sale End Date"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Typography color="GrayText">
                            Actual End Date
                          </Typography>
                          <TextField
                            size="small"
                            placeholder="Actual End Date"
                            variant="outlined"
                            disabled
                            value="Ooridoo"
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ProjectProfile;
